"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = {
    extLoaded: 'teamious-screen-capture-ext-loaded',
    getScreenSourceId: 'teamious-screen-capture-get-source-id'
};
exports.actions = {
    call: 'teamious-screen-capture-call',
    answer: 'teamious-screen-capture-answer'
};
exports.errors = {
    screenPermissionDeied: 'screenPermissionDeied'
};
function isWellKnownMessage(message) {
    if (!message) {
        return false;
    }
    for (var type in exports.types) {
        if (exports.types[type] === message.type) {
            return true;
        }
    }
    return false;
}
exports.isWellKnownMessage = isWellKnownMessage;



//////////////////
// WEBPACK FOOTER
// ../screen-capture-chrome-extension/dist/message.js
// module id = 229
// module chunks = 0